const countryCodes = [
    { name: "United Arab Emirates", code: "AE", dial_code: "+971" },
    { name: "Afghanistan", code: "AF", dial_code: "+93" },
    { name: "Argentina", code: "AR", dial_code: "+54" },
    { name: "Austria", code: "AT", dial_code: "+43" },
    { name: "Australia", code: "AU", dial_code: "+61" },
    { name: "Bangladesh", code: "BD", dial_code: "+880" },
    { name: "Belgium", code: "BE", dial_code: "+32" },
    { name: "Bahrain", code: "BH", dial_code: "+973" },
    { name: "Brazil", code: "BR", dial_code: "+55" },
    // { name: "Canada", code: "CA", dial_code: "+1" },
    { name: "Switzerland", code: "CH", dial_code: "+41" },
    { name: "Chile", code: "CL", dial_code: "+56" },
    { name: "China", code: "CN", dial_code: "+86" },
    { name: "Colombia", code: "CO", dial_code: "+57" },
    { name: "Germany", code: "DE", dial_code: "+49" },
    { name: "Denmark", code: "DK", dial_code: "+45" },
    { name: "Egypt", code: "EG", dial_code: "+20" },
    { name: "Spain", code: "ES", dial_code: "+34" },
    { name: "Finland", code: "FI", dial_code: "+358" },
    { name: "France", code: "FR", dial_code: "+33" },
    { name: "United Kingdom", code: "GB", dial_code: "+44" },
    { name: "Greece", code: "GR", dial_code: "+30" },
    { name: "Hong Kong", code: "HK", dial_code: "+852" },
    { name: "Hungary", code: "HU", dial_code: "+36" },
    { name: "Indonesia", code: "ID", dial_code: "+62" },
    { name: "Ireland", code: "IE", dial_code: "+353" },
    { name: "India", code: "IN", dial_code: "+91" },
    { name: "Italy", code: "IT", dial_code: "+39" },
    { name: "Japan", code: "JP", dial_code: "+81" },
    { name: "Kenya", code: "KE", dial_code: "+254" },
    { name: "South Korea", code: "KR", dial_code: "+82" },
    { name: "Sri Lanka", code: "LK", dial_code: "+94" },
    { name: "Morocco", code: "MA", dial_code: "+212" },
    { name: "Mexico", code: "MX", dial_code: "+52" },
    { name: "Malaysia", code: "MY", dial_code: "+60" },
    { name: "Nigeria", code: "NG", dial_code: "+234" },
    { name: "Netherlands", code: "NL", dial_code: "+31" },
    { name: "Norway", code: "NO", dial_code: "+47" },
    { name: "Nepal", code: "NP", dial_code: "+977" },
    { name: "New Zealand", code: "NZ", dial_code: "+64" },
    { name: "Oman", code: "OM", dial_code: "+968" },
    { name: "Peru", code: "PE", dial_code: "+51" },
    { name: "Pakistan", code: "PK", dial_code: "+92" },
    { name: "Poland", code: "PL", dial_code: "+48" },
    { name: "Portugal", code: "PT", dial_code: "+351" },
    { name: "Qatar", code: "QA", dial_code: "+974" },
    { name: "Romania", code: "RO", dial_code: "+40" },
    { name: "Russia", code: "RU", dial_code: "+7" },
    { name: "Saudi Arabia", code: "SA", dial_code: "+966" },
    { name: "Sweden", code: "SE", dial_code: "+46" },
    { name: "Singapore", code: "SG", dial_code: "+65" },
    { name: "Thailand", code: "TH", dial_code: "+66" },
    { name: "Turkey", code: "TR", dial_code: "+90" },
    { name: "Taiwan", code: "TW", dial_code: "+886" },
    { name: "Ukraine", code: "UA", dial_code: "+380" },
    { name: "United States", code: "US", dial_code: "+1" },
    { name: "Vietnam", code: "VN", dial_code: "+84" },
    { name: "South Africa", code: "ZA", dial_code: "+27" }
];

export default countryCodes;
